import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LanIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lan"}/>
}
